function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoDl = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M20 .66c.152.059.3.113.457.172 2.363 1.043 4.082 3.184 5.168 5.496.246.738.3 1.281.246 2.055 1.875-1.309 1.875-1.309 3.027-3.242.067-.57.067-.57-.421-1.172-.665-.266-.665-.266-1.301-.438V3.31c.941.066 1.566.128 2.402.578.422.523.422.523.477 1.226-.262 1.149-1.04 1.973-1.793 2.828-.157.18-.313.356-.469.54-5.27 5.695-14.18 8.824-21.711 9.16-1.758.011-3.687-.141-5.21-1.098-.638-.723-.923-1.473-.981-2.438.199-1.578 1.297-2.765 2.5-3.738.484-.152.484-.152.87-.219-.074.176-.144.352-.218.536-.262.953-.387 1.793-.219 2.773.719 1.035 1.43 1.258 2.61 1.543 4.16.363 8.27-.625 12.175-1.984.145-.051.286-.102.434-.153 1.46-.422 1.46-.422 2.43-1.48q.086-.283.18-.574c.077-.153.152-.305.234-.465.703-1.41.879-2.66.523-4.211-.457-1.403-1.215-2.434-2.523-3.113-1.633-.766-2.985-.711-4.68-.145-1.387.574-2.098 1.563-2.703 2.902-.453 1.414-.45 2.887.168 4.246.816 1.391 1.871 2.172 3.328 2.77.613.172.613.172 1.086.223v.441c-3.012.719-6.016 1.434-9.129 1.324-1.258-2.55-1.387-5.398-.504-8.094C7.527 3.966 9.36 1.941 11.957.66c2.566-1.058 5.465-.972 8.043 0m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fbfbfb",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.086 10.367c-.152 1.121-.602 2.102-1.035 3.133q-.122.302-.25.605l-.82 1.957c-.188.45-.376.895-.563 1.344q-.704 1.681-1.414 3.364-.371.879-.742 1.765c-.344.828-.696 1.652-1.043 2.48-.13.297-.25.594-.375.891-1.2 2.864-1.2 2.864-2.235 3.875-.96.324-1.793.367-2.746 0-1.226-1.05-1.894-2.73-2.597-4.168-.09-.18-.176-.36-.27-.547q-.279-.568-.559-1.132-.42-.868-.855-1.735l-.543-1.105q-.129-.257-.258-.52c-.433-.887-.804-1.754-1.086-2.707l.446-.094c5.668-1.207 10.812-2.894 15.402-6.554 1.07-.852 1.07-.852 1.543-.852m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fcfcfc",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.281 3.46c1.114.595 1.973 1.5 2.371 2.716.11 1.37.168 2.597-.652 3.75-1.086 1.105-1.867 1.574-3.437 1.613-1.141-.012-1.786-.14-2.649-.95-1.043-1.179-1.41-2.046-1.375-3.616.145-1.196.633-2.043 1.484-2.864 1.332-.882 2.696-1.168 4.258-.648m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fdfdfd",
    fillOpacity: 1
  }
}));
export { SvgLogoDl as ReactComponent };
export default __webpack_public_path__ + "assets/images/logo-dl.svg";